import useDefinedContext from "hooks/useDefinedContext";
import { createContext } from "react";
import type { LoadVelocityProfile } from "types/load-velocity-profile";

export interface ChartCompareProfileSelectContextType {
  value: LoadVelocityProfile[];
  onChange(profiles: LoadVelocityProfile[]): void;
  options: LoadVelocityProfile[];
}

const ChartCompareProfileSelectContext = createContext<ChartCompareProfileSelectContextType | undefined>(undefined);
ChartCompareProfileSelectContext.displayName = "ChartCompareProfileSelectContext";

export function useChartCompareProfileSelectContext() {
  return useDefinedContext(ChartCompareProfileSelectContext);
}

export default ChartCompareProfileSelectContext;
